module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "page content",
    class: !_vm.loading ? '' : 'loading'
  }, [(_vm.notFound) ? _c('not-found') : _vm._e(), _vm._v(" "), (_vm.currentPost && _vm.currentPost.publishStatus === 'publish') ? _c('div', [(_vm.currentPost.postType === 'episode') ? _c('episode', {
    attrs: {
      "episode": _vm.currentPost
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentPost.postType === 'extra') ? _c('extra', {
    attrs: {
      "extra": _vm.currentPost
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentPost.postType === 'page') ? _c('page', {
    attrs: {
      "page": _vm.currentPost
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51db8cb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Post.vue
// module id = 780
// module chunks = 1